function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=356&deploy=1&compid=3905695&ns-at=AAEJ7tMQXEZU2fo4DdZ-RdNWyrLXe8l4ghQtxmyHcYsrl7XUVJ8","customscript_ns_sc_ext_sl_sn_sub:customdeploy_create_subscription":"/app/site/hosting/scriptlet.nl?script=937&deploy=1&compid=3905695&ns-at=AAEJ7tMQtLPDlREHz-8c9yABwO1ZhlxuYZ4ozXVsRZME93Al6kc","customscript_ns_sc_sl_sn_get_subs:customdeploy_ns_sc_sl_sn_get_subs":"/app/site/hosting/scriptlet.nl?script=936&deploy=1&compid=3905695&ns-at=AAEJ7tMQfycxWz6u95N0vWs32tJe16lIzLYnni7Qo4WWesnHaLE","customscript_ns_sc_sl_sn_isb:customdeploy_ns_sc_sl_sn_isb":"/app/site/hosting/scriptlet.nl?script=1180&deploy=1&compid=3905695&ns-at=AAEJ7tMQHWjzuMQzt35xz-CFUpZquDNKMksu0c6y_TkSgaSZx0Y","customscript_ns_sc_sl_sn_subswitch:customdeploy_ns_sc_sl_sn_subswitch":"/app/site/hosting/scriptlet.nl?script=935&deploy=1&compid=3905695&ns-at=AAEJ7tMQ4qetvlECWU81gVNBETMA_pQvXJVfGtQXOFerAkVD0V8"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}